import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

export function RequireAuth() {
  const auth = useAuth();
  const loc = useLocation();
  if (!auth.ready) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }
  if (!auth.signedIn) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return <Outlet />;
}
